import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { CadensSharedModule } from '../../shared';

import {
    GrhumService
} from './';

@NgModule({
    imports: [
        CadensSharedModule
    ],
    declarations: [
    ],
    entryComponents: [
    ],
    providers: [
        GrhumService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CadensGrhumModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/grhum/grhum.module.ts